import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
  selector: "grafana-item",
  templateUrl: "grafana-item.html",
  styleUrl: "../../shortcut-menu.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class GrafanaItem {
  protected subscription = input.required<{
    customCustomerAbbreviation?: string | null;
    description: string;
    monitoringEnabled: boolean;
  }>();
  protected grafanaUrl = computed(() => {
    // Todo: rewrite so it not relies on the description but on the customCustomerAbbreviation
    const { description } = this.subscription();
    const parts = description.split(" ").filter(Boolean);
    return `https://grafana.${parts[parts.length - 1].toLowerCase()}.automation.surf.net/dashboards`;
  });
}
